import { createSlice } from "@reduxjs/toolkit";
import { initialAICodingState } from "./aiCodingState";

const aiCodingSlice = createSlice({
  name: "aiCoding",
  initialState: initialAICodingState,
  reducers: {
    resetAddAICodingJobOpenedState: (state) => {
      state.isAddAICodingJobOpened = false;
    },
    setAddAICodingJobOpenedState: (state, { payload }: { payload: boolean }) => {
      state.isAddAICodingJobOpened = payload;
    },
  },
});

export const { setAddAICodingJobOpenedState, resetAddAICodingJobOpenedState } = aiCodingSlice.actions;
export default aiCodingSlice.reducer;
